module.exports = __webpack_public_path__ + "static/media/vintage_bottlers.f59ebe7a.png";